module.exports = __webpack_public_path__ + "static/media/s_v5_t1_1.cd852b1c.mp3";